import { createFileRoute } from '@tanstack/react-router';
import CustomerNew from '@/pages/CustomerNew';

/**
 * Create Customer Route (/customers/new)
 * 
 * Implements Requirements 6.1, 6.2, 6.3:
 * - TanStack Router for type-safe routing
 * - Nested routes with layout composition
 * - Automatic code splitting per route
 * 
 * Protected route for creating a new customer.
 * Inherits authentication guard from _authenticated layout.
 */

export const Route = createFileRoute('/_authenticated/customers/new')({
  component: CustomerNew,
});
